interface MyStyles {
  display?: string;
  flexDirection?: 'row' | 'column';
  justifyContent?: string;
  padding?: string;
  alignItems?: string;
}

const commonStyles = {
  fontWeight: 500,
  color: 'primary.dark',
  padding: '10px 13px',
};
export const Styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '0px',
  },
  tipHeading: {
    color: '242528',
    fontSize: { xs: '16px', md: '20px' },
    fontWeight: '600',
    lineHeight: 'normal',
  },
  textAreaBox: {
    width: '90%',
    margin: '0px auto',
  },
  textAreaCustom: {
    position: 'relative',
    paddingBottom: '15px',
  },
  textfield: {
    background: '#F3F3F3',
    '& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder': {
      fontSize: '12px',
    },
    '& fieldset': { border: 'none' },
    paddingRight: '15%',
  },
  caption: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: '20px',
    position: 'absolute',
    bottom: '5px',
    right: '5px',
  },
  textAreaHeading: {
    color: '#242528',
    fontSize: { xs: '16px', md: '20px' },
    fontWeight: 600,
    lineHeight: 'normal',
    marginTop: '23px',
    marginBottom: '15px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 15px',
    backgroundColor: '#fff',
  } as MyStyles,
  cartItemContainer: {
    marginBottom: 10,
    padding: '0px 13px',
  },
  instructionContainer: {
    background: '#fff',
    marginTop: '40px',
    borderRadius: '12px',
    paddingBottom: '20px',
    // marginTop:"-100px"
  },

  cartContainer: {
    height: '35px',
    width: '60px',
    backgroundColor: '#ECECF5',

    borderRadius: '360px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  headerLeftContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  itemsContainer: {
    display: 'flex',
    width: { xs: '95%', md: '98%' },
    margin: '0px auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '10px',
  } as MyStyles,
  cartIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  } as MyStyles,
  headerText: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#000000',
  },
  crossIcon: {
    height: 40,
    width: 40,
    fontWeight: 500,
    color: '#000000',
  },
  cartCounter: {
    fontSize: 16,
    fontWeight: 500,
    color: '#000000',
    padding: '10px',
  },
  itemheading: {
    ...commonStyles,
    fontSize: {
      xs: '16px',
      md: '20px',
    },
    fontWeight: 600,
    color: '#000000',
  },

  addMoretext: {
    ...commonStyles,
    fontSize: {
      xs: '16px',
      md: '18px',
    },
    display: 'flex',
    alignItems: {
      xs: 'flex-start',
      md: 'center',
    },
    padding: { xs: '10px 5%', md: '10px 3%' },
    cursor: 'pointer',
  },
  formButton: {
    height: '44px',
    width: '90%',
    margin: '20px 0px 20px 0px',
    borderRadius: '7px',
    fontWeight: 500,
    fontSize: '16px',
    cursor: 'pointer',
  },

  emptyCartContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '15%',
  },
  emptyCartText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#797979',
    p: 2,
  },
  addButton: {
    height: 38,
    width: 138,
    backgroundColor: 'primary.dark',
    borderRadius: '7px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  addIcon: {
    color: 'white',
    width: '26px',
    height: '26px',
  },
  additemButtonText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
  loginModal: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  loginModalHeading: {
    fontSize: {
      xs: '20px',
      md: '28px',
    },
    fontWeight: 500,
    color: '#000000',
    paddingBottom: '25px',
    textAlign: 'center',
  },
  loginModalBtns: {
    display: 'flex',
    gap: '15px',
  },
  loginModalBtn: {
    width: '234px',
    fontWeight: 500,
    fontSize: '16px',
    height: '49px',
    cursor: 'pointer',
  },
  checkoutModalBtn: {
    marginTop: '25px',
    fontWeight: 500,
    fontSize: '16px',
    color: 'primary.dark',
    cursor: 'pointer',
  },
  closeBtn: {
    position: 'absolute',
    top: {
      xs: '15px',
      md: '30px',
    },
    right: {
      xs: '10px',
      md: '25px',
    },
    cursor: 'pointer',
  },

  divider: { width: { xs: '90px', sm: '210px' }, background: '#888D95' },
  createAccount: {
    fontWeight: 500,
    fontSize: '16px',
    color: 'primary.dark',
    padding: '20px 0px 30px 0px',
    cursor: 'pointer',
  },
  orSection: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#242528',
    padding: '0px 20px',
  },
  dividerContainer: { display: 'flex', alignItems: 'center', marginTop: '30px' },
  accwarning: {
    marginTop: '20px',
    marginBottom: '55px',
  },
  guestPopup: {
    width: '100%',
    paddingTop: '48px',
    paddingBottom: '48px',
    position: 'relative',
  },
  openTabButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 0px',
    gap: '20px',
    width: '100%',
  },
  pointTableContainer: { display: 'flex', justifyContent: 'space-between', marginBottom: '5px' },
  pointTableInnerContainer: { display: 'flex', alignItems: 'center' },
  pointsTableTitle: { fontSize: '14px', fontWeight: 400, color: '#242528', marginLeft: { md: '15px' } },
  seemoreContainer: {
    fontSize: '16px',
    fontWeight: 500,
    color: 'primary.dark',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  orderHeading: {
    fontWeight: 600,
    fontSize: { xs: '16px', md: '20px' },
    cursor: 'pointer',
    // marginLeft: '15px',
  },

  desktopRecommendationContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    paddingTop: '20px',
    gap: '5px',
  },
  downArrow: {
    position: 'fixed',
    bottom: '100px',
    display: 'flex',
    left: {
      xs: '45%',
      md: '58%',
    },
    transition: 'transform 0.3s', // Smooth transition for the shake effect

    // Define the animation
    '@keyframes shake': {
      '0%, 100%': {
        transform: 'translateY(0)',
      },
      '10%, 30%, 50%, 70%, 90%': {
        transform: 'translateY(-2px)',
      },
      '20%, 40%, 60%, 80%': {
        transform: 'translateY(2px)',
      },
    },
    animation: 'shake 5s ease infinite',
    cursor: 'pointer',
  },
  delayTimeMsg: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    alignItems: 'center',
    py: 0.5,
    px: 1.5,
    fontSize: '12px',
    color: '#D5381D',
    width: 'auto',
    backgroundColor: '#D5381D26',
    '@media (max-width: 780px)': {
      width: '100%',
    },
    borderRadius: '8px',
  },
};
